import { useSyncExternalStore } from "react";

export const useOnlineStatus = () => {
    const subscribe = (callback: EventListener) => {
        window.addEventListener("online", callback);
        window.addEventListener("offline", callback);

        return () => {
            window.removeEventListener("online", callback);
            window.removeEventListener("offline", callback);
        };
    };

    const getSnapshot = () => window.navigator.onLine;

    const getServerSnapshot = () => true;

    const isOnline = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

    return {
        isOnline
    };
};
